import React from "react"; // the following slices get loaded not lazily, in order to
// to prevent loaders flickering on the product page
// e.g. when configurator loader gets substituted by three-dot-loader

import SliceColorSample from "../SliceColorSample/SliceColorSample";
import SliceInspiration from "../SliceInspiration/SliceInspiration";
import SliceInstagramPosts from "../SliceInstagramPosts/SliceInstagramPosts";
import SliceInstagramStatic from "../SliceInstagramStatic/SliceInstagramStatic";
import SliceLabeledIcons from "../SliceLabeledIcons/SliceLabeledIcons";
import SliceProductDetails from "../SliceProductDetails/SliceProductDetails";
import SliceProductFeatures from "../SliceProductFeatures/SliceProductFeatures";
/* eslint-disable prettier/prettier */

var SliceArchitectReviews = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceArchitectReviews" */
  "../SliceArchitectReviews/SliceArchitectReviews");
});
var SliceBenefits = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceBenefits" */
  "../SliceBenefits/SliceBenefits");
});
var SliceBenefitsProgram = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceBenefitsProgram" */
  "../SliceBenefitsProgram/SliceBenefitsProgram");
});
var SliceCollections = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceCollections" */
  "../SliceCollections/SliceCollections");
});
var SliceConsultToolbox = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceConsultToolbox" */
  "../SliceConsultToolbox/SliceConsultToolbox");
});
var SliceBlogContentTextPhoto = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceBlogContentTextPhoto" */
  "../SliceBlogContentTextPhoto/SliceBlogContentTextPhoto");
});
var SliceBlogContentTextText = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceBlogContentTextText" */
  "../SliceBlogContentTextText/SliceBlogContentTextText");
});
var SliceBlogContentPhotoPhoto = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceBlogContentPhotoPhoto" */
  "../SliceBlogContentPhotoPhoto/SliceBlogContentPhotoPhoto");
});
var SliceOurPartners = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceOurPartners" */
  "../SliceOurPartners/SliceOurPartners");
});
var SliceDownloadFiles = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceDownloadFiles" */
  "../SliceDownloadFiles/SliceDownloadFiles");
});
var SliceRelatedPagesSlyder = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceRelatedPagesSlyder" */
  "../SliceRelatedPagesSlyder/SliceRelatedPagesSlyder");
});
var SliceCta = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceCta" */
  "../SliceCta/SliceCta");
});
var SliceIconCta = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceIconCta" */
  "../SliceIconCta/SliceIconCta");
});
var SliceAccordion = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceAccordion" */
  "../SliceAccordion/SliceAccordion");
});
var SliceLinkButton = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceLinkButton" */
  "../SliceLinkButton/SliceLinkButton");
});
var SliceRichText = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceRichText" */
  "../SliceRichText/SliceRichText");
});
var SliceTagImage = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceTagImage" */
  "../SliceTagImage/SliceTagImage");
});
var SliceFormEmbded = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceFormEmbded" */
  "../SliceFormEmbded/SliceFormEmbded");
});
var SliceIconBanner = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceIconBanner" */
  "../SliceIconBanner/SliceIconBanner");
});
var SliceMediaSlider = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceMediaSlider" */
  "../SliceMediaSlider/SliceMediaSlider");
});
var SliceQuote = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceQuote" */
  "../SliceQuote/SliceQuote");
});
var SliceShowRoom = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceShowRoom" */
  "../SliceShowRoom/SliceShowRoom");
});
var SliceTrusted = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceTrusted" */
  "../SliceTrusted/SliceTrusted");
});
var SliceExerpt = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceExerpt" */
  "../SliceExerpt/SliceExerpt");
});
var SliceHeroImg = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceHeroImg" */
  "../SliceHeroImg/SliceHeroImg");
});
var SliceReviews = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceReviews" */
  "../SliceReviews/SliceReviews");
});
var SliceInstagramFeed = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceInstagramFeed" */
  "../SliceInstagramFeed/SliceInstagramFeed");
});
var SliceFranchiseContact = React.lazy(function () {
  return import(
  /* webpackChunkName: "SliceFranchiseContact" */
  "../SliceFranchiseContact/SliceFranchiseContact");
});
/* eslint-enable prettier/prettier */

var getComponent = function getComponent(componentName) {
  switch (componentName) {
    case "architectreviews":
      return SliceArchitectReviews;

    case "benefits":
      return SliceBenefits;

    case "benefitsprogram":
      return SliceBenefitsProgram;

    case "collections":
      return SliceCollections;

    case "color_sample":
      return SliceColorSample;

    case "consulttoolbox":
      return SliceConsultToolbox;

    case "cta":
      return SliceCta;

    case "franchisecontact":
      return SliceFranchiseContact;

    case "inspiration":
      return SliceInspiration;

    case "instagram_feed":
      return SliceInstagramFeed;

    case "instagram_posts":
      return SliceInstagramPosts;

    case "instagram":
      return SliceInstagramStatic;

    case "labeled_icons":
      return SliceLabeledIcons;

    case "product_details":
      return SliceProductDetails;

    case "product_features":
      return SliceProductFeatures;

    case "reviews":
      return SliceReviews;

    case "showroom":
      return SliceShowRoom;

    case "trusted":
      return SliceTrusted;

    case "excerpt":
      return SliceExerpt;

    case "heroimg":
      return SliceHeroImg;

    case "iconbanner":
      return SliceIconBanner;

    case "mediaslider":
      return SliceMediaSlider;

    case "quote":
      return SliceQuote;

    case "richtext":
      return SliceRichText;

    case "tagimage":
      return SliceTagImage;

    case "formembded":
      return SliceFormEmbded;

    case "iconcta":
      return SliceIconCta;

    case "accordion":
      return SliceAccordion;

    case "linkbutton":
      return SliceLinkButton;

    case "ourpartners":
      return SliceOurPartners;

    case "downloadfiles":
      return SliceDownloadFiles;

    case "relatedpagesslider":
      return SliceRelatedPagesSlyder;

    case "content_text_photo_60_30":
      return SliceBlogContentTextPhoto;

    case "content_photo_text_30_60":
      return SliceBlogContentTextPhoto;

    case "content_text_text_50":
      return SliceBlogContentTextText;

    case "content_photo_photo_50":
      return SliceBlogContentPhotoPhoto;

    default:
      return undefined;
  }
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types


export function SliceComponent(props) {
  var componentName = props.type;

  if (!componentName) {
    console.error("Slice type not found. Probably you should update a query for it.");
    return null;
  }

  var Component = getComponent(componentName);

  if (!Component) {
    console.error("component \"".concat(componentName, "\" was not found"));
    return null;
  }

  return React.createElement(Component, props);
}